import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from '../../../notes/button/button.module';
import { ReadMorePipe } from '../../pipes/read-more.pipe';
import { ReadMoreComponent } from './read-more.component';

@NgModule({
  declarations: [ReadMoreComponent, ReadMorePipe],
  imports: [ButtonModule, CommonModule],
  exports: [ReadMoreComponent],
})
export class ReadMoreModule {}
